import { Table } from 'antd';
import moment from 'moment';
const AddAdjustment = ({
  currency,
  originalPrice,
  projectCreatedDate,
  adjustments
}) => {
  const columns = [{
    title: 'Date',
    dataIndex: 'created_date',
    key: 'created_date',
    render: date => moment(date).format('DD/MM/YYYY HH:mm')
  }, {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    render: amount => `${currency}${amount.toFixed(2)}`
  }, {
    title: 'Reason',
    dataIndex: 'reason',
    key: 'reason'
  }, {
    title: 'Added By',
    dataIndex: 'actor',
    key: 'actor'
  }];
  const originalPriceItem = {
    reason: 'Original Price',
    amount: originalPrice,
    created_date: moment(projectCreatedDate).toDate()
  };
  return <>
      <Table dataSource={[...adjustments, originalPriceItem].sort((a, b) => moment(a.created_date).diff(moment(b.created_date)))} columns={columns} size="small" pagination={false} summary={() => <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>Final Price</Table.Summary.Cell>
              <Table.Summary.Cell index={1}>
                {currency}
                {adjustments.reduce((acc, item) => acc + item.amount, originalPrice).toFixed(2)}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>} />
    </>;
};
export default AddAdjustment;